import { Component } from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

const ES_VERSION_ANTIGUA = (msg = "") =>
  /chunkloaderror|loading chunk|loading css chunk|dynamically imported module|unexpected token '<'/i
    .test(msg);

/** Evita pantallas en blanco: recarga sola si la caché tiene una versión antigua. */
export class ErrorBoundary extends Component {
  state = { fallo: false };

  static getDerivedStateFromError() {
    return { fallo: true };
  }

  componentDidCatch(error) {
    const mensaje = `${error?.name || ""} ${error?.message || ""}`;
    if (ES_VERSION_ANTIGUA(mensaje) && !sessionStorage.getItem("bspark_recarga")) {
      sessionStorage.setItem("bspark_recarga", "1");
      window.location.reload();
    }
  }

  render() {
    if (!this.state.fallo) return this.props.children;
    return (
      <div className="min-h-screen grid place-items-center px-6 bg-background" data-testid="pantalla-error">
        <div className="max-w-md text-center">
          <AlertTriangle className="h-12 w-12 text-primary mx-auto" />
          <h1 className="font-display text-3xl font-extrabold mt-6">Algo no ha cargado bien</h1>
          <p className="text-sm text-muted-foreground mt-3">
            Ha habido un problema al mostrar esta página. Vuelve a cargarla y sigue donde lo dejaste;
            si se repite, escríbenos y lo revisamos.
          </p>
          <Button className="rounded-full font-semibold mt-8 w-full" data-testid="recargar-btn"
            onClick={() => {
              sessionStorage.removeItem("bspark_recarga");
              window.location.reload();
            }}>
            Volver a cargar
          </Button>
        </div>
      </div>
    );
  }
}
